// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"da15d0b2","112":"16ad0a06","335":"0c3dc8da","440":"fae86444","507":"56698034","606":"f7e89bfa","785":"c2953727"}[chunkId] + ".chunk.js";
};